export const List = () => import("./Group/List.vue");
export const GroupCreate = () => import("./Group/Create.vue");
export const GroupEdit = () => import("./Group/Edit.vue");

export const Ledger = () => import("./Ledger/List.vue");
export const LedgerCreate = () => import("./Ledger/Create.vue");
export const LedgerEdit = () => import("./Ledger/Edit.vue");
export const LedgerView = () => import("./Ledger/View.vue");

export const LedgerBarcode = () => import("./Ledger/Barcode.vue");

export const CostCenter = () => import("./CostCenter/List.vue");
export const CostCenterCreate = () => import("./CostCenter/Create.vue");
export const EditCostCenter = () => import("./CostCenter/Edit.vue");
